import { SET_TRIMS } from './actionTypes';
import { RESET_APP_STATE } from 'store/actionTypes';
import initialState from 'store/initialState';

export default function(state = initialState.trims, action) {
  switch (action.type) {
    case SET_TRIMS:
      return action.payload;
    case RESET_APP_STATE:
      return initialState.trims;
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/store/reducers/trims/reducer.js